import { CommonEnums } from '../../common.enums';

export class DxMp_Fwd_Lnk {
	dxMp_Id: number;
	obj_Id: number;
	fwd_Lnk_Obj_Id: number;
	grp_Id: number;
	fwd_Lnk_Grp_Id: number;
	obj_Cd: string;
	fwd_Lnk_Obj_Cd: string;
	lnkNm: string;
	ref_Obj_Id: number;
	error_Cd: string;
	error_Msg: string;
	obj_Nm: string;
	fwd_Obj_Nm: string;
	change_Ind: string;
	dbtyp_Id: number;

	constructor() {
		this.setDefault();
	}

	setDefault() {
		this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
		this.obj_Id = CommonEnums.defaults.LONG_VAL;
		this.fwd_Lnk_Obj_Id = CommonEnums.defaults.LONG_VAL;
		this.grp_Id = CommonEnums.defaults.LONG_VAL;
		this.fwd_Lnk_Grp_Id = CommonEnums.defaults.LONG_VAL;
		this.obj_Cd = CommonEnums.defaults.STRING_EMPTY;
		this.fwd_Lnk_Obj_Cd = CommonEnums.defaults.STRING_EMPTY;
		this.lnkNm = CommonEnums.defaults.STRING_EMPTY;
		this.ref_Obj_Id = CommonEnums.defaults.LONG_VAL;
		this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
		this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
		this.obj_Nm = CommonEnums.defaults.STRING_EMPTY;
		this.fwd_Obj_Nm = CommonEnums.defaults.STRING_EMPTY;
		this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
		this.dbtyp_Id = CommonEnums.defaults.LONG_VAL;
	}

	static parse(dxMp_Fwd_LnkTmp: DxMp_Fwd_Lnk): DxMp_Fwd_Lnk {
		let dxMp_Fwd_Lnk: DxMp_Fwd_Lnk = new DxMp_Fwd_Lnk();
		dxMp_Fwd_Lnk.copyFrom(dxMp_Fwd_LnkTmp as DxMp_Fwd_Lnk);
		return dxMp_Fwd_Lnk;
	}

	getPrimaryKey(): string {
		return this.dxMp_Id + '.' + this.obj_Id + '.' + this.fwd_Lnk_Obj_Id + '.' + this.grp_Id + '.' + this.fwd_Lnk_Grp_Id;
	}

	copy(): DxMp_Fwd_Lnk {
		let dxMp_Fwd_LnkTmp: DxMp_Fwd_Lnk = new DxMp_Fwd_Lnk();

		dxMp_Fwd_LnkTmp.dxMp_Id = this.dxMp_Id;
		dxMp_Fwd_LnkTmp.obj_Id = this.obj_Id;
		dxMp_Fwd_LnkTmp.fwd_Lnk_Obj_Id = this.fwd_Lnk_Obj_Id;
		dxMp_Fwd_LnkTmp.grp_Id = this.grp_Id;
		dxMp_Fwd_LnkTmp.fwd_Lnk_Grp_Id = this.fwd_Lnk_Grp_Id;
		dxMp_Fwd_LnkTmp.obj_Cd = this.obj_Cd;
		dxMp_Fwd_LnkTmp.fwd_Lnk_Obj_Cd = this.fwd_Lnk_Obj_Cd;
		dxMp_Fwd_LnkTmp.lnkNm = this.lnkNm;
		dxMp_Fwd_LnkTmp.ref_Obj_Id = this.ref_Obj_Id;
		dxMp_Fwd_LnkTmp.error_Cd = this.error_Cd;
		dxMp_Fwd_LnkTmp.error_Msg = this.error_Msg;
		dxMp_Fwd_LnkTmp.obj_Nm = this.obj_Nm;
		dxMp_Fwd_LnkTmp.fwd_Obj_Nm = this.fwd_Obj_Nm;
		dxMp_Fwd_LnkTmp.change_Ind = this.change_Ind;
		dxMp_Fwd_LnkTmp.dbtyp_Id = this.dbtyp_Id;

		return dxMp_Fwd_LnkTmp;
	}

	copyFrom(dxMp_Fwd_LnkTmp: DxMp_Fwd_Lnk): void {
		this.dxMp_Id = dxMp_Fwd_LnkTmp.dxMp_Id;
		this.obj_Id = dxMp_Fwd_LnkTmp.obj_Id;
		this.fwd_Lnk_Obj_Id = dxMp_Fwd_LnkTmp.fwd_Lnk_Obj_Id;
		this.grp_Id = dxMp_Fwd_LnkTmp.grp_Id;
		this.fwd_Lnk_Grp_Id = dxMp_Fwd_LnkTmp.fwd_Lnk_Grp_Id;
		this.obj_Cd = dxMp_Fwd_LnkTmp.obj_Cd;
		this.fwd_Lnk_Obj_Cd = dxMp_Fwd_LnkTmp.fwd_Lnk_Obj_Cd;
		this.lnkNm = dxMp_Fwd_LnkTmp.lnkNm;
		this.ref_Obj_Id = dxMp_Fwd_LnkTmp.ref_Obj_Id;
		this.error_Cd = dxMp_Fwd_LnkTmp.error_Cd;
		this.error_Msg = dxMp_Fwd_LnkTmp.error_Msg;
		this.obj_Nm = dxMp_Fwd_LnkTmp.obj_Nm;
		this.fwd_Obj_Nm = dxMp_Fwd_LnkTmp.fwd_Obj_Nm;
		this.change_Ind = dxMp_Fwd_LnkTmp.change_Ind;
		this.dbtyp_Id = dxMp_Fwd_LnkTmp.dbtyp_Id;
	}

	compare(dxMp_Fwd_LnkTmp: DxMp_Fwd_Lnk): string {
		let dxMp_Fwd_LnkString: string = this.toString(false);
		let dxMp_Fwd_LnkTmpString: string = dxMp_Fwd_LnkTmp.toString(false);

		if (dxMp_Fwd_LnkString != dxMp_Fwd_LnkTmpString) {
			return (dxMp_Fwd_LnkString + ',' + dxMp_Fwd_LnkTmpString);
		}

		return '';
	}

	toString(isNotCompare: boolean = true): string {
		let str: string = "DxMp_Fwd_Lnk [dxMp_Id=" + this.dxMp_Id + ", obj_Id=" + this.obj_Id +
			", fwd_Lnk_Obj_Id=" + this.fwd_Lnk_Obj_Id + ", grp_Id=" + this.grp_Id +
			", fwd_Lnk_Grp_Id=" + this.fwd_Lnk_Grp_Id + ", obj_Cd=" + this.obj_Cd + ", fwd_Lnk_Obj_Cd=" + this.fwd_Lnk_Obj_Cd +
			", lnkNm=" + this.lnkNm + ", ref_Obj_Id=" + this.ref_Obj_Id +
			", obj_Nm=" + this.obj_Nm + ", fwd_Obj_Nm" + this.fwd_Obj_Nm + ", dbtyp_Id" + this.dbtyp_Id;

		if (isNotCompare) {
			str += ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg + ", change_Ind" + this.change_Ind;
		}

		str += ']';
		return str;
	}
}
